import {Injectable, NgModule} from '@angular/core';
import {SdDialog, SdDialogConfig, SdDialogModule, SdDialogRef} from './dialog';
import {ComponentType} from '@angular/cdk/portal';

export class SdBottomSheetConfig<D = unknown> extends SdDialogConfig<D> {}

export class SdBottomSheetRef<T = unknown, R = unknown> extends SdDialogRef<T, R> {}

@Injectable({providedIn: 'root'})
export class SdBottomSheet {
  constructor(private readonly dialog: SdDialog) {}

  open<T, D = unknown, R = unknown>(component: ComponentType<T>, config: SdBottomSheetConfig<D> = {}): SdBottomSheetRef<T, R> {
    return this.dialog.open(component, {
      ...config,
      panelClass: ['sd-bottom-sheet', ...(Array.isArray(config.panelClass) ? config.panelClass : config.panelClass ? [config.panelClass] : [])],
    }) as SdBottomSheetRef<T, R>;
  }
}

@NgModule({
  imports: [SdDialogModule],
  exports: [],
  providers: [SdBottomSheet],
})
export class SdBottomSheetModule {}
